import { render } from "./About.vue?vue&type=template&id=5a1223ee"
const script = {}
script.render = render

export default script